import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-guaranteed-icon',
  template: '<xpo-icon *ngIf="isGuaranteed" class="guaranteed-svg" iconName="SS_G"></xpo-icon>',
  styles: ['.xpo-Icon.guaranteed-svg > .mat-icon { padding: 7px 0 0 0; margin: 2px 0; height: 24px; }'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuaranteedIconComponent implements ICellRendererAngularComp, IHeaderAngularComp {
  isGuaranteed: boolean;

  constructor() {}

  agInit(params: any): void {
    this.isGuaranteed = params.header ? params.header : params.value;
  }

  refresh(): boolean {
    return false;
  }
}
